import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

import { ActionConstants } from '../constants/action.constants';

@Injectable()
export class ActionGeneratorService {

	public loadAll(config: any, payload: any[]): Action {
		return this.generateAction(ActionConstants.LOAD_ALL, config, payload);
	}

	public addOne(config: any, payload: any): Action {
		return this.generateAction(ActionConstants.ADD_ONE, config, payload);
	}

	public addMany(config: any, payload: any): Action {
		return this.generateAction(ActionConstants.ADD_MANY, config, payload);
	}

	public updateOne(config: any, payload: any): Action {
		return this.generateAction(ActionConstants.UPDATE_ONE, config, payload);
	}

	public updateMany(config: any, payload: any): Action {
		return this.generateAction(ActionConstants.UPDATE_MANY, config, payload);
	}

	public removeOne(config: any, payload: string): Action {
		return this.generateAction(ActionConstants.REMOVE_ONE, config, payload);
	}

	public selectOne(config: any, payload: string): Action {
		return this.generateAction(ActionConstants.SELECT_ONE, config, payload);
	}

	public loadOne(config: any, payload: any): Action {
		return this.generateAction(ActionConstants.LOAD_ONE, config, payload);
	}

	public noAction(): Action {
		return this.generateAction(ActionConstants.NO_ACTION, 'GENERIC', null);
	}

	private generateAction(type: string, config: any, payloadInput: any): Action {
		if (!type || !config) {
			throw new Error('Error in generateAction: type and name cannot be empty!');
		}

		const name = (typeof config !== 'string' && config.hasOwnProperty('name')) ? config['name'] : config;

		class NewAction implements Action {
			public readonly type = type.toUpperCase() + name.toUpperCase();
			constructor(public payload: any) { }
		}
		return new NewAction(payloadInput);
	}
}
